// extracted by mini-css-extract-plugin
module.exports = {"template":"styles_template__sGXVZ","template__list":"styles_template__list__3Xapz","template__item":"styles_template__item__c_VNy"};